import {
  FormBlockItem,
  ItemProps,
  blockItem,
} from "src/components/FormWithBlocks";
import { ZAttribute } from "src/types/ZAttribute";
import { AttrTypeName } from "src/types/AttrType";
import { AttrUploaderProps } from "src/common/attrEdit/components";
import { PlmUploader } from "src/components/PlmUploader/PlmUploader";

export const buildUploader = (
  attr: ZAttribute,
  typeName: string,
  itemProps: ItemProps,
  compProps: AttrUploaderProps,
  disabled: boolean,
): FormBlockItem =>
  blockItem(
    String(attr.id),
    attr.name,
    PlmUploader,
    { isImage: typeName === AttrTypeName.image, ...compProps, disabled },
    itemProps,
  );
